// Copyright (c) Ping. All rights reserved.
//
// Small browser-platform probes for the call subsystem. Safari is the weakest
// WebRTC target we support (tight simultaneous-decoder ceiling, heavier encode
// cost on Intel Macs, autoplay quirks), so several perf levers are tuned down
// when we detect it. Detection is best-effort UA sniffing — only ever used to
// pick *safer* defaults, never to gate functionality, so a false positive just
// means slightly more conservative media settings.

let cached: boolean | null = null;

/**
 * True for desktop + iOS Safari (and any WKWebView), false for Chrome/Edge/
 * Firefox/Chromium — including the Chrome-on-iOS (`crios`) / Firefox-on-iOS
 * (`fxios`) shells, which are Blink/Gecko despite running on WebKit underneath
 * on iOS. We treat them as non-Safari because their WebRTC stack behaves like
 * their desktop counterparts.
 */
export function isSafari(): boolean {
  if (cached !== null) return cached;
  if (typeof navigator === 'undefined') return (cached = false);
  const ua = navigator.userAgent;
  cached = /^((?!chrome|chromium|android|crios|fxios|edg|opr).)*safari/i.test(ua);
  return cached;
}
